module.exports = "https://p.cds.unp.clasificados.pe/montserrat-regular.301746f13bbe20d1ebb340595dc94dc7.woff2";